import type { CSSProperties } from "react";

export interface SkeletonProps {
  width?: number | string;
  height?: number | string;
  rounded?: number | string;
  className?: string;
  style?: CSSProperties;
}

export function Skeleton({
  width = "100%",
  height = 12,
  rounded = 4,
  className,
  style,
}: SkeletonProps) {
  return (
    <span
      className={className ? `sk ${className}` : "sk"}
      style={{
        display: "inline-block",
        width,
        height,
        borderRadius: rounded,
        ...style,
      }}
    />
  );
}
